import React, { useEffect, useState } from "react";
import { getBase64 } from "../../../utils/functionUtils";
import { Button, Upload } from "antd";
import { DownloadOutlined, FileExcelTwoTone, UploadOutlined, CloseCircleTwoTone } from '@ant-design/icons';
import { useCentralStore } from "../../../store/appContext";
import API from "../../../api";
import ActionTypes from "../../../store/actionTypes";
import resources from "../../../components/common/resources.json";
import axios from 'axios';

const SalesReportDocumentTable = ({
  salesReportData,
}) => {
  let tableColumns = [];
  const totalKeys = {};
  const [{ clientData, carrierThemeData, userData, userDetails, reportFilterDuration }, dispatch] = useCentralStore();
  const setLoading = (action) => {
    dispatch({ type: ActionTypes.SET_LOADING, payload: action });
  };
  const [reportList, setReportList] = useState([]);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

  function formatDurationToReportRange(duration) {
    const [year, month] = duration.split("-");
    const monthName = monthNames[parseInt(month, 10) - 1];
    return `${monthName}-${year}`;
  }

  const formattedDuration = formatDurationToReportRange(reportFilterDuration.duration);

  const filteredReports = reportList.filter(
    report => report.ReportRange === formattedDuration
  );

  salesReportData?.reduce((acc, current) => {
    const keys = Object.keys(current);
    for (var i in keys) {
      totalKeys[keys[i]] = 1;
    }
  }, totalKeys);

  var keys = Object.keys(totalKeys);
  for (var i in keys) {
    if (keys[i] !== 'Months' && keys[i] !== 'ClientName') {
      tableColumns.push({
        colName: keys[i]?.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      });
    }
  }

  let getFinanceReportList = () => {
    API[ActionTypes.GET_FIANANCE_REPORTS_DETAILS](userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
      .then(({ data }) => {
        setReportList(data?.GetAllFinanceReport)
      })
      .catch((err) => {
        dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
        let _payload = {
          level: resources.POST_LOGGER_ERROR,
          category: resources.POST_LOGGER_API,
          ApiName: resources.POST_LOGGER_APINAME,
          message: {
            error: err,
            info: {
              idToken: "",
            },
          },
        };
        API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
      });
  }

  useEffect(() => {
    getFinanceReportList();
    // eslint-disable-next-line
  }, []);

  const downloadReport = ({ ReportType, Range }) => {
    let payload = {
      ReportType,
      Range
    };
    setLoading(true);
    API[ActionTypes.SGP_DOWNLOAD_REPORT](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
      .then(({ data }) => {
        if (data) {
          axios({
            url: data?.DownloadReportResponse?.Result,
            method: 'GET',
            responseType: 'blob',
          }).then((response) => {
            setLoading(false);
            const href = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', `Report_data_${Range}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          })
            .catch(() => {
              setLoading(false);
            })
        }
      })
      .catch((err) => {
        setLoading(false);
        dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
        let _payload = {
          level: resources.POST_LOGGER_ERROR,
          category: resources.POST_LOGGER_API,
          ApiName: resources.POST_LOGGER_APINAME,
          message: {
            error: err,
            info: {
              idToken: "",
            },
          },
        };
        API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
      });
  }

  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);

  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);
      return false;
    },
    fileList,
    maxCount: 1
  };

  const { theme } = carrierThemeData;

  const dynamicStyle = {
    color: theme?.colors?.primary,
    borderColor: theme?.colors?.primary,
    background: 'white'
  };

  const uploadSelectedFile = async () => {
    setUploading(true);
    const base64Obj = await getBase64(fileList[0]);

    let fileBaseName = fileList?.[0]?.name?.split(".")[0];
    let payload = {
      ReportType: fileBaseName,
      ReportName: fileBaseName,
      ReportData: base64Obj,
      ReportRange: formattedDuration
    }

    setLoading(true);
    API[ActionTypes.UPLOAD_FIANANCE_REPORT](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
      .then(() => {
        setLoading(false);
        setUploading(false);
        setFileList([])
        getFinanceReportList()
      })
      .catch((err) => {
        setLoading(false);
        setUploading(false);
        setFileList([])
        dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
        let _payload = {
          level: resources.POST_LOGGER_ERROR,
          category: resources.POST_LOGGER_API,
          ApiName: resources.POST_LOGGER_APINAME,
          message: {
            error: err,
            info: {
              idToken: "",
            },
          },
        };
        API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
      });
  };

  return (
    <div className="mx-auto w-full mt-2">
      <div className="flex flex-row justify-between">
        <div className="font-bold my-0 py-0">Client Collaborated Feedback</div>
        <div>
          <Upload {...props} showUploadList={false}>
            {fileList?.length === 0 && (
              <Button icon={<UploadOutlined className="uploadIcon" />} className="borderStyle" style={dynamicStyle}>
                Upload file
              </Button>
            )}
          </Upload>
          {fileList.length > 0 && (
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 8 }}>
              <span style={{ marginRight: 8 }}>{fileList[0].name}</span>
              <Button
                type="text"
                danger
                size="small"
                onClick={() => setFileList([])}
                style={{ padding: 0, display: 'flex', alignItems: 'center' }}
                icon={<CloseCircleTwoTone  />}
                aria-label="Remove file"
              />
            </div>
          )}
          {/* Only show upload button if file is selected */}
          {fileList.length > 0 && (
            <Button
              type="button"
              onClick={uploadSelectedFile}
              className="textFontStyle"
              style={dynamicStyle}
              disabled={fileList?.length === 0}
              loading={uploading}
            >
              {uploading ? 'Uploading' : 'Click to Upload'}
            </Button>
          )}
        </div>
      </div>
      <table className="tableSalesReport w-full">
        <thead>
          <tr>
            <th>DOCUMENTS</th>
            <th>DOWNLOAD</th>
          </tr>
        </thead>
        <tbody>
          {filteredReports && filteredReports.length > 0 ? (
            filteredReports.map((v, i) => (
              <tr key={i}>
                <td>{v?.ReportName}</td>
                <td className="tableFileReport">
                  <DownloadOutlined 
                    className="force-theme-color"
                    style={{ fontSize: 24, cursor:'pointer'}} 
                    onClick={() => downloadReport({ ReportType: v.ReportName, Range: v.ReportRange })}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={2} style={{ textAlign: 'center', color: '#888', padding: '16px 0' }}>
                No reports available for the selected period.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SalesReportDocumentTable;
